<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      size="mini"
      type="primary"
      @click="dialogVisible = true"
    >
      上传图片
    </el-button>

    <!--

<el-upload
                action=""
                :http-request="uploadFile"
                :on-remove="handleRemove"
                :on-change="handleChangeFile1"
                :auto-upload="false"
                :limit="1"
                :file-list="ruleForm.imgList"
                list-type="picture"
                style="width: 300px"
              >
                <el-button size="mini" type="primary" plain
                  >点击上传<i class="el-icon-upload el-icon--right"></i
                ></el-button>
                <div slot="tip" class="el-upload__tip">
                  <span style="color: red">推荐尺寸(750*340)</span>
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>

  -->

    <!--

<el-dialog :visible.sync="dialogVisible" append-to-body>
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        action="https://httpbin.org/post"
        list-type="picture-card"
      >
        <el-button size="small" type="primary"> 上传图片 </el-button>
      </el-upload>


-->

    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <el-upload
      :http-request="uploadFile"
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-change="handleChangeFile"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        action=""
        list-type="picture-card"
      >
        <el-button size="small" type="primary"> 上传图片 </el-button>
      </el-upload>

      <el-button size="small" type="primary" @click="handleSubmit">
        插入
      </el-button>

      <el-button size="small" @click="dialogVisible = false"> 取消 </el-button>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from 'api/qiniu'
import uploadFile from "@/config/uploadFile";

export default {
  name: "EditorSlideUpload",
  props: {
    color: {
      type: String,
      default: "#1890ff",
    },
  },
  data() {
    return {
      dialogVisible: false,
      uploadFileTime: false,
      listObj: {},
      fileList: [],
    };
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        (item) => this.listObj[item].hasSuccess
      );
    },
    handleSubmit() {
 
      this.$emit("successCBK", this.fileList);
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess(response, file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.files.file;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    beforeUpload(file) {
      const _self = this;
      const _URL = window.URL || window.webkitURL;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        console.log(reject);
        const img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function () {
          _self.listObj[fileName] = {
            hasSuccess: false,
            uid: file.uid,
            width: this.width,
            height: this.height,
          };
        };
        resolve(true);
      });
    },

    uploadFile() {},

    async handleChangeFile(file, fileList, status, index) {

      console.log("fileList");
      console.log(fileList);

      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index);
      }
    },

    async uploadFileOss(list, status, index) {
      this.uploadFileTime = true;

      console.log("status");
      console.log(status);
      console.log("index");
      console.log(index);

      console.log("list");
      console.log(list);

      await uploadFile(list, this.$store.state.user.userInfo.code+'/exam/images').then(
        (res) => {
          console.log("res");
          console.log(res);
          this.fileList = res;
          this.uploadFileTime = false;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep .el-upload--picture-card {
    width: 100%;
  }
}
</style>
